module.exports = __webpack_public_path__ + "img/qita.25ad198c.png";